module.exports = __webpack_public_path__ + "img/logo.85932702.png";